import request from './request'

let affiliateInfo = {}
// Declare action type enums
const EVENT_ACTION = Object.freeze({
  click: 'click',
  keydown: 'keydown',
  mouseover: 'mouseover',
  mouseout: 'mouseout'
})

const EVENTS = {
  link: {
    action: EVENT_ACTION.click,
    id: 'link'
  },
  stock_legend: {
    action: EVENT_ACTION.click,
    id: 'stock_legend'
  },
  stock_sort: {
    action: EVENT_ACTION.click,
    id: 'stock_sort'
  },
  publication_filter: {
    action: EVENT_ACTION.click,
    id: 'publication_filter'
  },
  'feedback-submit': {
    action: EVENT_ACTION.click,
    event: 'feedback'
  },
  'feedback-cancel': {
    action: EVENT_ACTION.click,
    event: 'feedback'
  },
  user_agent: {
    id: 'user_agent'
  }
}

const trackEvent = ({ type, value }) => {
  const event = {
    email: affiliateInfo.email,
    affiliateid: affiliateInfo.id,
    customerid: affiliateInfo.customerid,
    ...EVENTS[type],
    target: {
      type,
      value
    }
  }

  request.push(event)
}

const trackPageView = () => { }

export default {
  /**
   *
   * @param {Object} el element the directive is bound to
   * @param {Object} binding an object that contains bound element properties
   */
  bind (el, binding) {
    el.addEventListener(EVENTS[binding.arg].action,
      trackEvent.bind(this, { type: binding.arg, value: binding.value }))
  },

  trackEvent,
  trackPageView,
  affiliateInfo
}
